import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import '../css/weekview.css';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { calculateDayColor, getDateStringForUrl, getFlowsInDay } from '../../helpers/CalendarHelper';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';

function Weekdates(props) {
    const history = useHistory();
    const location = useLocation();

    const onDateClick = (date) => {
        const flowsInDay = getFlowsInDay(date, props.entries);
        const dateStr = getDateStringForUrl(date);
        history.push(`${location.pathname}/${dateStr}}`,
            {
                flows: flowsInDay,
                view: props.view ?? 'W'
            }
        );
    }

    return (
        <TransitionGroup component={null}>
            <CSSTransition
                key={uuidv4()}
                exit={false} //Stops any exit animation classes from being applied
                timeout={500}
                classNames={props.clickState === 'next' ? 'slide-next' : 'slide-prev'}
            >
                <div className='weekdays-container'>
                    {
                        props.currentWeek.map((day, i) => {
                            let dayColor = calculateDayColor(day, props.entries);
                            const isDayClickable = dayColor === 'none' ? false : true;
                            return (
                                <div className='weekday-cell' key={i} >
                                    <div className='week-date' style={{ background: dayColor, color: "white", cursor: isDayClickable ? 'pointer' : 'none' }}
                                        onClick={isDayClickable ? () => onDateClick(day) : undefined}
                                    >
                                        {typeof (day) !== 'string' ? day.getDate() : ""}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </CSSTransition>
        </TransitionGroup>
    )
}

export default Weekdates